/** HashRouter search param that records the in-app screen for Android/browser Back. */
export const APP_STEP_PARAM = 'rz';

export const KNOWN_APP_STEPS = new Set([
  'home',
  'form',
  'dashboard',
  'projectDocuments',
  'financementDossier',
  'scenario',
  'report',
  'amortization',
  'myFiles',
  'about',
  'clients',
  'checklists',
  'marketParams',
]);

export function getAppStepFromSearch(search) {
  const raw = typeof search === 'string' && search.startsWith('?') ? search.slice(1) : search || '';
  const step = new URLSearchParams(raw).get(APP_STEP_PARAM);
  if (!step || step === 'home') return 'home';
  return KNOWN_APP_STEPS.has(step) ? step : 'home';
}

/** Keep share= / invitation= / etc. while writing the app step. */
export function searchWithAppStep(search, step) {
  const raw = typeof search === 'string' && search.startsWith('?') ? search.slice(1) : search || '';
  const params = new URLSearchParams(raw);
  if (!step || step === 'home') params.delete(APP_STEP_PARAM);
  else params.set(APP_STEP_PARAM, step);
  const next = params.toString();
  return next ? `?${next}` : '';
}

/** Completing a screen should replace it so Back skips the finished form. */
export function shouldReplaceAppStep(prevStep, nextStep) {
  return (
    (prevStep === 'form' && nextStep === 'dashboard') ||
    (prevStep === 'scenario' && nextStep === 'report') ||
    (prevStep === 'report' && nextStep === 'scenario')
  );
}

/** In-app ← Retour should pop HashRouter history, not push a shallower URL. */
export function isAppStepBackTransition(prevStep, nextStep) {
  if (nextStep === 'home' && prevStep && prevStep !== 'home') return true;
  if (nextStep === 'dashboard' && (prevStep === 'report' || prevStep === 'scenario' || prevStep === 'projectDocuments' || prevStep === 'financementDossier')) {
    return true;
  }
  if (prevStep === 'amortization' && nextStep === 'report') return true;
  return false;
}
